(() => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll(".swiper-slider").forEach(el => {
        let customEffect = {};

        if (el.classList.contains("custom-effect")) {
            customEffect = {
                effect: "slide",
                watchSlidesProgress: true,
                virtualTranslate: true,
                on: {
                    init(swiper) {
                        swiper.slides.forEach((slide) => {
                            slide.style.transitionProperty = 'transform, clip-path';
                            const progress = slide.progress;
                            const tx = -slide.swiperSlideOffset;
                            let clipRight = progress <= 0 ? Math.min(Math.abs(progress) * 100, 100) : 0;

                            slide.style.transform = `translateX(${tx}px)`;
                            slide.style.clipPath = `inset(0 0 0 ${clipRight}%)`;
                        });
                        void swiper.wrapperEl.offsetHeight;
                    },

                    setTranslate(swiper) {
                        const { slides } = swiper;

                        slides.forEach((slide) => {
                            const progress = slide.progress;

                            const tx = -slide.swiperSlideOffset;

                            let clipRight = 0;
                            let zIndex = 0;

                            if (progress <= 0) {
                                clipRight = Math.min(Math.abs(progress) * 100, 100);
                                zIndex = 2;
                            } else {
                                clipRight = 0;
                                zIndex = 1;
                            }

                            slide.style.transform = `translateX(${tx}px)`;
                            slide.style.zIndex = zIndex;
                            slide.style.clipPath = `inset(0 0 0 ${clipRight}%)`;
                        });
                    },

                    setTransition(swiper, duration) {
                        const { slides } = swiper;

                        slides.forEach((slide) => {
                            slide.style.transitionDuration = `${duration}ms`;
                        });

                        if (duration !== 0) {
                            clearTimeout(swiper.customTimeout);

                            swiper.customTimeout = setTimeout(() => {
                                swiper.animating = false;
                                swiper.emit('transitionEnd');
                            }, duration);
                        }
                    }
                }
            }
        }

        let sw = new Swiper(el, Object.assign({}, defaultSettings, el.dataset.swiper ? JSON.parse(el.dataset.swiper) : {}, customEffect));

        const syncingEls = Array.from(document.querySelectorAll(sw.params.syncing));

        sw.on("slideChange", function () {
            const idx = this.realIndex;

            if (syncingEls.length)
                for (const el of syncingEls) {
                    if (!el.swiper)
                        continue;

                    el.swiper.slideToLoop(idx);
                }
        });
    });
})();